// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vR2-j"};